import React from "react";

const BpayContext = React.createContext();
export default BpayContext;
